import { render } from "./HomeJa.vue?vue&type=template&id=475b6e12&scoped=true"
import script from "./HomeJa.vue?vue&type=script&lang=js"
export * from "./HomeJa.vue?vue&type=script&lang=js"

import "./HomeJa.vue?vue&type=style&index=0&id=475b6e12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475b6e12"]])

export default __exports__